export const convertTextWithEntitiesToNormalText = (textWithEntities: string): string => {
    if(!textWithEntities) {
        return textWithEntities;
    }
    const decoder = document.createElement('span')
    decoder.innerHTML = textWithEntities
    return decoder.innerText
}